import { render, staticRenderFns } from "./selectUserAndDept.vue?vue&type=template&id=051c793d&"
import script from "./selectUserAndDept.vue?vue&type=script&lang=js&"
export * from "./selectUserAndDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports